import type { ReactNode } from 'react';
import { Button, Space, Typography } from 'antd';
import { ClearOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Props {
  /** 筛选控件。 */
  children: ReactNode;
  /** 当前生效的条件数，来自 useListFilter。 */
  active: number;
  /** 筛完之后列表里还剩几行。 */
  resultCount: number;
  onReset: () => void;
}

/**
 * 列表页筛选栏。
 *
 * 🔴 筛选生效时**必须明说「这不是全部」**。在一个付款系统里，一张被筛过的表和一张
 * 空表长得一模一样 —— 财务看到「没有待打款的申请」就会以为活干完了，而实际上只是
 * 昨天顺手勾的一个币种还留在那儿。这行小字就是防这件事的。
 */
export default function FilterBar({ children, active, resultCount, onReset }: Props) {
  return (
    <div style={{ marginBottom: 16 }}>
      <Space wrap size={8} align="center">
        {children}
        {active > 0 && (
          <Button type="link" size="small" icon={<ClearOutlined />} onClick={onReset}>
            清空筛选
          </Button>
        )}
      </Space>
      {active > 0 && (
        <div style={{ marginTop: 6 }}>
          <Text type="warning" style={{ fontSize: 12 }}>
            已按 {active} 个条件筛选，当前显示 {resultCount} 条 —— 这不是全部记录。
          </Text>
        </div>
      )}
    </div>
  );
}
